import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import Questions from './Questions';
import { getAllQuestionsInitiate } from '../../actions/questions';

const mapStateToProps = state => {
  const questions = _get(state, 'questions', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  return {
    questions,
    selectedWorkspace,
    fetchingQuestions:
      _get(state, 'apiState.GET_QUESTIONS.isFetching', true) &&
      !_get(state, 'apiState.GET_QUESTIONS.isIdle', false),
    fetchedQuestions: _get(state, 'apiState.GET_QUESTIONS.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllQuestions: payload => dispatch(getAllQuestionsInitiate(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Questions);
